<template>
  <div class="titleContainer">
    <el-input
      v-if="isTitleEditing"
      ref="titleInput"
      v-model="newTitle"
      class="videoTitleInput"
      type="text"
      maxlength="100"
      @blur="setTitle"
      @keyup.enter.native="setTitle"
      @keyup.esc.native="resetTitle"
    />
    <span
      v-else
      :title="title + ' (Click to change)'"
      class="videoTitleLabel"
      @click="startSetTitle"
      >{{ title }}</span
    >
  </div>
</template>

<script>
// @group Media/Video
// Video card's title
export default {
  name: "VideoHeaderTitle",
  model: {
    prop: "title",
    event: "updateTitle"
  },
  props: {
    /** Video title */
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      /** entered title */
      newTitle: this.title,
      /** is title changing right now */
      isTitleEditing: false
    };
  },
  methods: {
    // @vuese
    // Start edit clip title
    startSetTitle() {
      this.isTitleEditing = true;
      // User begin title editing
      this.$emit("updateTitleStart");

      // focus input when it will replace span
      this.$nextTick(() => {
        this.$refs.titleInput.focus();
      });
    },
    // @vuese
    // Save entered title
    setTitle() {
      if (this.isTitleEditing) {
        if (this.newTitle.length === 0) {
          this.$refs.titleInput.focus();
          return;
        }
        if (this.newTitle !== this.title) {
          this.$emit("updateTitle", this.newTitle);
        }
        this.resetTitle();
      }
    },
    // @vuese
    // Cancel title editing ant return old one
    resetTitle() {
      this.isTitleEditing = false;
    }
  }
};
</script>

<style>
.titleContainer {
  text-align: start;
}
.videoTitleInput {
  margin-right: 5px;
  margin-top: -5px;
  font-size: 10px;
}
.videoTitleLabel {
  font-size: 16px;
  max-width: 100%;
  display: inline-block;
  margin-right: 10px;
  text-decoration: none;
  border-bottom: 1px dashed #ffffff;
  cursor: pointer;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  max-width: 235px;
}

@media only screen and (max-width: 767px) {
  .videoTitleLabel {
    font-size: 12px;
  }
}
@media only screen and (min-width: 1500px) {
  .videoTitleLabel {
    font-size: 15px !important;
  }
}
@media only screen and (min-width: 1920px) {
  .videoTitleLabel {
    font-size: 17px !important;
  }
}
</style>
